import type { BidType, BidTypeName } from 'api/elplan/elplan.types'

export function resolveBidInputCurrency(
  bidTypes: BidType[] | undefined,
  bidTypeName: BidTypeName,
  systemCurrency?: string
): string {
  const bidTypeCurrency = bidTypes?.find((bidType) => bidType.type === bidTypeName)?.currency
  return bidTypeCurrency ?? systemCurrency ?? 'SEK'
}
